import { styled, Tooltip, tooltipClasses } from "@mui/material"


const CustomTooltip = styled( ( { className, ...props } ) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
) )( ( { theme, ...rest } ) => {
    return ( {

        [`& .${tooltipClasses.arrow}`]: {
            color: rest.bg || theme.palette.primary.main,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: rest.bg || theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            padding: "10px",
            fontStyle: "italic",
            borderRadius: "5px",
        },
    } )
} )

export default CustomTooltip